<template>
  <div>
    <div>
      <Area
        :info-card="computedInfoCard"
        :data-series="computedBandwithSeries"
        :time-stamps="timeStamps"
        :format-percentage="true"
      />
      <div class="my-1 col-lg-12 col-12 d-flex flex-wrap px-0 mx-0">
        <div class="col-lg-4 col-md-6 col-12 pl-0">
          <SimpleDonutChart
            :cached-data="bandwidthCachedData.number || 0"
            :no-cached-data="bandwidthNoCacheData.number || 0"
            :loading-donut-data="bandwidthLoaded"
            :colors="['#3A81F6', '#F2A342']"
          />
        </div>
        <div class="col-lg-8 col-md-6 col-12 px-0">
          <alert-info
            class="xs-mt-1"
            icon-name="Info"
            icon-color="text-secondary"
            info-title="Information"
            info-title-class="text-main"
            :description="computedDescriptionInfo"
            description-class="text-secondary text-bold"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Area from '../widgets/Area.vue'
import SimpleDonutChart from '../widgets/SimpleDonutChart.vue'
import AlertInfo from '@/components/analytics/components/AlertInfo.vue'

export default {
  components: {
    Area,
    AlertInfo,
    SimpleDonutChart,
  },
  computed: {
    bandwidth() {
      return this.$store.state.analytics.bandwidth ?? []
    },
    bandwidthCachedData() {
      return this.$store.state.analytics.bandwidthCachedData
    },
    bandwidthNoCacheData() {
      return this.$store.state.analytics.bandwidthNoCacheData
    },
    bandwidthPercentile() {
      return this.$store.state.analytics.bandwidthPercentile
    },
    loadingBandwidthPercentile() {
      return this.$store.state.analytics.loadingBandwidthPercentile
    },
    computedInfoCard() {
      const infoCard = [
        // look for v1 cdn
        {
          id: 1,
          title: '95th percentile',
          description: this.formatBytes(this.bandwidthPercentile),
          elipseColor: '',
          loading: this.bandwidthLoaded && this.loadingBandwidthPercentile,
        },
        {
          id: 2,
          title: 'Peak',
          description: this.formatBytes(this.bandwidth.peak) || '-',
          elipseColor: '',
          loading: this.bandwidthLoaded,
        },
        {
          id: 3,
          title: 'Peak Time',
          description: this.unixTimestampToDateTime(this.bandwidth.peak_Time),
          elipseColor: '',
          loading: this.bandwidthLoaded,
        },
      ]
      return infoCard
    },
    computedDescriptionInfo() {
      const descriptionInfo = [
        {
          id: 1,
          description: 'Cached ratio is a percentage value between cache hits and cache misses. The higher your cached ratio is, the faster is the data delivery.',
        },
        {
          id: 2,
          description: 'For websites with static content, it\'s typical to have a 90% and higher cached ratio. For dynamic websites, where content changes frequently, the cached ratio will be slightly lower.',
        },
        {
          id: 3,
          description: 'If your cached ratio is lower than 70%, feel free to <a href="https://www.google.com">contact our support team</a> so they can help you with the optimization.',
        },
      ]
      return descriptionInfo
    },
    bandwidthLoaded() {
      return this.$store.state.analytics.loadginBandwidth
    },
    computedBandwithSeries() {
      return this.getBandwidthSeries(this.bandwidth?.result)
    },
    timeStamps() {
      if (this.computedBandwithSeries && this.computedBandwithSeries.length > 0) {
        return this.formatTimestamps(this.computedBandwithSeries[0])
      }
      return null
    },
  },
  methods: {
    getBandwidthSeries(dataList) {
      const names = ['bandwidthCached', 'bandwidthNonCached']
      const result = dataList?.filter(item => names.includes(item.name))
        .map(item => ({
          name: item.name === names[0] ? 'Cached data ratio' : 'Non-cached data ratio',
          data: item?.data?.map(data => data.value) ?? [],
          timestamps: item?.data?.map(data => data.timestamp) ?? [],
          total: item.total,
        }))
      return result
    },
    formatTimestamps(data) {
      if (!data.timestamps) return []

      return data.timestamps.map(timestamp => parseInt(timestamp, 10))
    },
  },
}
</script>
